import React from 'react'

import GenericGrid from '../../../../components/grid/grid'
import { renderColumns } from '../../../../utils/helper'

import columns from '../by-model-column'

const dData = [
    {
        id:"1",
        name:"Safety Population",
        Abbreviation:"SAF",
        Description:"All subjects receiving FPV or FPV/RTV at any dose",
        Treatment:"as-treated",
        Usage:"Safety summaries/listings (cumulative throughout study; and events after 05July2011 through end of study)"
    },
    {
        id:"2",
        name:"Baseline Virology Population",
        Abbreviation:"BVP",
        Description:"All enrolled subjects with Day 1 (Baseline) data or Screening HIV resistance testing data",
        Treatment:"as-treated",
        Usage:"Virology analyses (baseline virology/resistance testing)"
    },
    {
        id:"3",
        name:"Virological Failure Population",
        Abbreviation:"VFP",
        Description:"Subjects meeting confirmed virologic failure criteria (based on HIV-1 RNA thresholds/rebound rules) for the relevant analysis window (Week 24, Week 48, or after Week 48 through end of study).",
        Treatment:"as-treated",
        Usage:"Primary population for genotypic and phenotypic resistance analyses; disposition summaries of confirmed virologic failure by Week 48 vs after Week 48 through end of study"
    },
    {
        id:"4",
        name:"Virological Failure Population",
        Abbreviation:"VFP",
        Description:"Subjects meeting confirmed virologic failure criteria (based on HIV-1 RNA thresholds/rebound rules) for the relevant analysis window (Week 24, Week 48, or after Week 48 through end of study).",
        Treatment:"as-treated",
        Usage:"Primary population for genotypic and phenotypic resistance analyses; disposition summaries of confirmed virologic failure by Week 48 vs after Week 48 through end of study"
    },
    {
        id:"5",
        name:"Virological Failure Population",
        Abbreviation:"VFP",
        Description:"Subjects meeting confirmed virologic failure criteria (based on HIV-1 RNA thresholds/rebound rules) for the relevant analysis window (Week 24, Week 48, or after Week 48 through end of study).",
        Treatment:"as-treated",
        Usage:"Primary population for genotypic and phenotypic resistance analyses; disposition summaries of confirmed virologic failure by Week 48 vs after Week 48 through end of study"
    },
    {
        id:"6",
        name:"Virological Failure Population",
        Abbreviation:"VFP",
        Description:"Subjects meeting confirmed virologic failure criteria (based on HIV-1 RNA thresholds/rebound rules) for the relevant analysis window (Week 24, Week 48, or after Week 48 through end of study).",
        Treatment:"as-treated",
        Usage:"Primary population for genotypic and phenotypic resistance analyses; disposition summaries of confirmed virologic failure by Week 48 vs after Week 48 through end of study"
    },
    {
        id:"7",
        name:"Virological Failure Population",
        Abbreviation:"VFP",
        Description:"Subjects meeting confirmed virologic failure criteria (based on HIV-1 RNA thresholds/rebound rules) for the relevant analysis window (Week 24, Week 48, or after Week 48 through end of study).",
        Treatment:"as-treated",
        Usage:"Primary population for genotypic and phenotypic resistance analyses; disposition summaries of confirmed virologic failure by Week 48 vs after Week 48 through end of study"
    },
]

const ChatGpt = () => {
     const [dataState, setDataState] = React.useState({
      skip: 0,
      take: 100,
      sort: [],
      filter: null
    });

    const [ data , setData ] = React.useState( dData )

    const handleDataStateChange = (e) => {
       setDataState(e.dataState);
    };
  return (
    <>
             <GenericGrid
               data={data}
               columns={renderColumns(columns)}
               dataState={dataState}
               onDataStateChange={handleDataStateChange}
               pageable={false}
               sortable={false}
               filterable={false}
               style={{ height:"60vh" , width:"100%"  }}
               dataItemKey = { "id" }
              selectable={{
                        enabled: false,
                        mode: "single",
                        drag: false,
                        cell: false}}
               onSelectionChange={()=>{}}
               selectedRow = {null}
               storageField = {""}
               />
    </>
  )
}

export default ChatGpt